export const PW_REQS = [
  { label: "8+ characters", test: (p) => p.length >= 8 },
  { label: "Uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { label: "Number", test: (p) => /\d/.test(p) },
  { label: "Special character", test: (p) => /[^a-zA-Z0-9]/.test(p) },
];

export function pwStrength(p) {
  const s = PW_REQS.filter((r) => r.test(p)).length;
  if (!p) return null;
  if (s <= 1) return { label: "Weak", color: "#ef4444", width: "25%" };
  if (s <= 2) return { label: "Fair", color: "#eab308", width: "50%" };
  if (s === 3) return { label: "Good", color: "#3b82f6", width: "75%" };
  return { label: "Strong", color: "#22c55e", width: "100%" };
}

export function pct(val, max) {
  return Math.min(100, Math.round((parseFloat(val) / parseFloat(max)) * 100));
}

export const FILE_ICONS = {
  pdf: "📄",
  zip: "🗜️",
  image: "🖼️",
  sheet: "📊",
  slides: "📑",
};
